import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import { nextTick } from "vue/types/umd";

@Component({ name: "AccountRegister" })
export default class AccountRegister extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isFromNewsletter: boolean = false;
    public isNewsletterInterestsVisible: boolean = false;
    public options: any = null;
    public profileSegments: any[] = [];
    public newsletterInterests: any[] = [];
    public formData: any = { profileSegment: null, country: null, language: null };
    public validationErrors: any[] = [];
    public isHidden: boolean = true;
    public isHiddenCheck: boolean = true;
    public countries: any[] = [];
    public languages: any[] = [];
    public dataRow: string = "1";
    public widgetId: string = null;

    @Prop() readonly hcaptchaSiteKey: string;
    @Prop() readonly hcaptchaUrl: string;
    @Prop() readonly returnUrl: string;
    @Prop() readonly email: string;
    @Prop() readonly profileSegment: string;
    @Prop() readonly urlPrivacyPolicy: string;
    @Prop() readonly countryCode: string;
    @Prop() readonly language: string;
    @Prop() readonly showCountry: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.options = (await Axios.post(this.routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        await this.getCountries();

        this.profileSegments = this.options.profileSegments;
        this.formData.newsletterInterests = this.options.newsletterInterests.map(x => x.value);
        this.newsletterInterests = this.options.newsletterInterests;

        if (this.email && this.profileSegment) {
            this.formData.email = this.email;
            this.formData.profileSegment = this.profileSegment;

            this.isFromNewsletter = true;
            this.widgetId = (<any>window).hcaptcha.render("RegisterRecaptcha", { sitekey: this.hcaptchaSiteKey });
        } else {
            this.setRecapthca();
        }
    }

    public async getCountries() {
        const result = (await Axios.post(this.routes.Geo_GetCountries)).data;
        this.countries = result;

        this.formData.country = this.countryCode ? this.countries.find(x => x.code === this.countryCode)?.code : null;
        this.onCountrySelect();
        this.formData.language = this.language ? this.language : this.languages[0]?.value;
    }

    public setRecapthca() {
        let hcaptchaScript = document.createElement("script");
        hcaptchaScript.setAttribute("src", this.hcaptchaUrl);
        document.head.appendChild(hcaptchaScript);
    }

    public onCountrySelect() {
        let selectedLanguage = [];
        this.languages = [];
        if (this.formData.country) {
            for (const country of this.countries) {
                if (country.code === this.formData.country) {
                    selectedLanguage.push(country.languages);
                }
            }

            for (const language of selectedLanguage[0]) {
                this.languages.push(language);
            }

            this.formData.language = this.languages[0].value;

            this.dataRow = this.languages.length > 1 ? "2" : "1";
        }
    };

    public showNewsletterInterests() {
        this.isNewsletterInterestsVisible = !this.isNewsletterInterestsVisible;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            if (this.widgetId) {
                await (<any>window).hcaptcha.execute(this.widgetId, { async: true });
            }
            else {
                await (<any>window).hcaptcha.execute({ async: true });
            }
            let result = (await Axios.post(this.routes.Account_User_Register, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "hCaptchaVerificationToken": this.widgetId ? (<any>window).hcaptcha.getResponse(this.widgetId) : (<any>window).hcaptcha.getResponse() } })).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            this.formData.password = null;
            this.formData.passwordCheck = null;

            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        if (this.widgetId) {
            await (<any>window).hcaptcha.reset(this.widgetId);
        }
        else {
            await (<any>window).hcaptcha.reset();
        }

        this.isLoading = false;
    }

    public isEmailInUse(): boolean {
        return (this.validationErrors.length !== 0 && this.validationErrors.filter(x => x.message === this.localizer.get("Account.Common.Email_InUse")).length > 0);
    }

    public showPasswordIcon() {
        this.isHidden = !this.isHidden;
    }

    public showPasswordCheckIcon() {
        this.isHiddenCheck = !this.isHiddenCheck;
    }
};